import { render, staticRenderFns } from "./AddOnDialog.vue?vue&type=template&id=28dc4f7b&scoped=true&"
import script from "./AddOnDialog.vue?vue&type=script&lang=js&"
export * from "./AddOnDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddOnDialog.vue?vue&type=style&index=0&id=28dc4f7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dc4f7b",
  null
  
)

export default component.exports